<sim-basic-material-dialog [showClosingX]="false" [finished]="finished" [matDialogData]="data" [rect]="rect" [hideHeader]="true">
	<div dialogContent>
		<div class="bottom">
			<sim-component-loading-container
				[isLoading]="true"
				[showBackDrop]="true"
				[size]="'big'"
				[fullWidthLoadingCon]="true"
				[loadingIcon]="'fa ' + icon"
				[loadingMessage]="title"
				[loadingDescriptionMessage]="desc"
			>
				<div actions style="margin-bottom: 15px">
					@if (state.result !== RegisterResult.Success) {
						<button color="accent" mat-raised-button [routerLink]="'/'">
							{{ T.BACK_TO_DASHBOARD | translate }}
						</button>
					}

					@if (state.result === RegisterResult.Success) {
						<button color="accent" mat-raised-button (click)="ok()">
							{{ T.BUTTON_CLOSE | translate }}
						</button>
					}
				</div>
			</sim-component-loading-container>
		</div>
	</div>
</sim-basic-material-dialog>
